<script>
    import "./projectSlider.css";
    let projectImage = "./images/dummy-image.jpg";
</script>

<div>
    <div class="flex column-direction items-center project-slider">
        <div class="relative image-wrap">
            <img src={projectImage} alt="projectImage"/>
        </div>
    <a href="javascript:void(0)" class="view-more-btn">AXIE INFINITY</a>
    </div>
</div>